import { createApi } from "@reduxjs/toolkit/query/react";
import apiBaseQuery from "./axiosBaseQuery";

export const SUPPLIERS_ENGAGEMENT_API = "supplierEngagementApi";

export const supplierEngagementApi = createApi({
  reducerPath: SUPPLIERS_ENGAGEMENT_API,
  baseQuery: apiBaseQuery,
  tagTypes: ["supplierEngagement"],
  endpoints: (builder) => ({
    getSupplierEngagementData: builder.query({
      query: (supplierName) => ({
        url: "/emissions/manage-supplier-requests/",
        params: supplierName ? { supplier_name: supplierName } : {},
      }),
      providesTags: ["supplier-data"],
    }),
    getAllSuppliers: builder.query({
      query: () => ({
        url: "/emissions/pcf-suppliers/",
      }),
    }),
    createRequest: builder.mutation({
      query: (body) => ({
        url: `emissions/create-pcf-form-token/`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["supplierEngagementData"],
      onError: (error, arg) => {
        console.error("Create request failed:", error);
      },
    }),
    getPcfFormData: builder.query({
      query: (form_token) => {
        if (!form_token) {
          return undefined;
        }
        return {
          url: `emissions/get-pcf-data/?form_token=${form_token}`,
        };
      },
      transformResponse: (response) => {
        const item = response[0];
        let documentReference = item?.document_reference;

        if (typeof documentReference === "string") {
          try {
            const parsedArray = JSON.parse(
              documentReference.replace(/'/g, '"')
            );
            documentReference = Array.isArray(parsedArray)
              ? parsedArray
              : [documentReference];
          } catch (parseError) {
            console.error("Error parsing document_reference:", parseError);
            documentReference = [documentReference];
          }
        } else if (!Array.isArray(documentReference)) {
          documentReference = documentReference ? [documentReference] : [];
        }
        return {
          ...item,
          document_reference: documentReference,
        };
      },
    }),
    approvePcf: builder.mutation({
      query: (body) => ({
        url: `emissions/approve-pcf-data/`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["supplierEngagement", "supplierEngagementData"],
      onError: (error, arg) => {
        console.error("Create request failed:", error);
      },
    }),
    getImage: builder.query({
      query: (fileName) => ({
        url: `/emissions/download-pcf-doc/?file_name=${encodeURIComponent(
          fileName
        )}`,
      }),
    }),
    getClientEmails: builder.query({
      query: (params = {}) => {
        return {
          url: `/emissions/pcf-receiver/`,
          params: {
            type: "supplier",
            ...params,
          },
        };
      },
    }),
    getManualEntries: builder.query({
      query: (params = {}) => {
        return {
          url: `emissions/manual-pcf-data-list/`,
          params,
        };
      },
      providesTags: ["manualEntries"],
    }),
    saveManualEntry: builder.mutation({
      query: (body) => ({
        url: `/emissions/manual-pcf-data/`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["manualEntries", "supplier-data"],
    }),
    deleteManualEntry: builder.mutation({
      query: ({ id }) => ({
        url: `/emissions/manual-pcf-data-delete/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["manualEntries", "supplier-data"],
    }),
  }),
});

export const {
  useGetClientEmailsQuery,
  useGetSupplierEngagementDataQuery,
  useCreateRequestMutation,
  useGetPcfFormDataQuery,
  useApprovePcfMutation,
  useLazyGetImageQuery,
  useGetManualEntriesQuery,
  useSaveManualEntryMutation,
  useDeleteManualEntryMutation,
  useGetAllSuppliersQuery,
} = supplierEngagementApi;
